import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Checkbox,
  VStack,
  Button,
  ButtonGroup,
  Flex,
  useBreakpointValue,
  Tag,
  TagLabel,
  TagCloseButton,
  HStack,
  Text,
} from "@chakra-ui/react";

const FilterDrawer = ({
  isFilterOpen,
  setIsFilterOpen,
  filters,
  setFilters,
  onApply,
  onCancel
}) => {
  // Responsive: use a smaller margin on mobile if needed
  const drawerMargin = useBreakpointValue({ base: 2, md: 6 });

  const handleApply = () => {
    const selectedStatuses = Object.entries(filters)
      .filter(([_, isSelected]) => isSelected)
      .map(([status]) => status);
    onApply(selectedStatuses);
    setIsFilterOpen(false);
  };

  const getFilterLabel = (status) => {
    const labels = {
      Pending: "Pending",
      Draft: "Draft",
      'Under Review': "Under Review",
      Approved: "Approved",
      Rejected: "Rejected",
      Funded: "Funded",
      Incomplete: "Incomplete",
      Deleted: "Deleted",
      Closed: "Closed"
    };
    return labels[status] || status;
  };

  const handleRemoveFilter = (status) => {
    setFilters({ ...filters, [status]: false });
  };

  return (
    <Drawer
      isOpen={isFilterOpen}
      placement="right"
      onClose={() => setIsFilterOpen(false)}
      size="xs"
    >
      <DrawerContent
        bg="white"
        borderRadius="16px"
        mt={drawerMargin * 6}
        mb={drawerMargin}
        maxH={`calc(100vh - ${drawerMargin * 4 * 8}px)`} // 8px per chakra spacing unit
        height="auto"
        boxShadow="0px 4px 32px rgba(0,0,0,0.08)"
        display="flex"
        flexDirection="column"
        overflow="hidden"
      >
        <DrawerCloseButton
          position="absolute"
          right={4}
          top={4}
          color="gray.500"
          _hover={{ color: "gray.700" }}
        />
        <DrawerHeader
          borderBottomWidth="1px"
          py={4}
          px={6}
          fontSize="lg"
          fontWeight="500"
        >
          Filter By
        </DrawerHeader>
        <DrawerBody px={6} pt={6} pb={0} flex="1" overflowY="auto">
          {/* Active Filters Section */}
          {Object.entries(filters).some(([_, isSelected]) => isSelected) && (
            <VStack align="start" spacing={3} mb={6}>
              <Text fontSize="sm" fontWeight="500" color="gray.600">
                Active Filters:
              </Text>
              <Flex wrap="wrap" gap={1}>
                {Object.entries(filters)
                  .filter(([_, isSelected]) => isSelected)
                  .map(([status]) => (
                    <Tag
                      key={status}
                      size="md"
                      borderRadius="full"
                      variant="solid"
                      colorScheme="purple"
                    //   mb={1}
                    >
                      <TagLabel>{getFilterLabel(status)}</TagLabel>
                      <TagCloseButton onClick={() => handleRemoveFilter(status)} />
                    </Tag>
                  ))}
              </Flex>
            </VStack>
          )}
          <VStack align="start" spacing={4}>
            <Checkbox
              isChecked={filters.Pending}
              onChange={(e) => setFilters({ ...filters, Pending: e.target.checked })}
              colorScheme="purple"
              size="lg"
            >
              Pending
            </Checkbox>
            <Checkbox
              isChecked={filters.Draft}
              onChange={(e) => setFilters({ ...filters, Draft: e.target.checked })}
              colorScheme="purple"
              size="lg"
            >
              Draft
            </Checkbox>
            <Checkbox
              isChecked={filters['Under Review']}
              onChange={(e) => setFilters({ ...filters, 'Under Review': e.target.checked })}
              colorScheme="purple"
              size="lg"
            >
              Under Review
            </Checkbox>
            <Checkbox
              isChecked={filters.Approved}
              onChange={(e) => setFilters({ ...filters, Approved: e.target.checked })}
              colorScheme="purple"
              size="lg"
            >
              Approved
            </Checkbox>
            <Checkbox
              isChecked={filters.Rejected}
              onChange={(e) => setFilters({ ...filters, Rejected: e.target.checked })}
              colorScheme="purple"
              size="lg"
            >
              Rejected
            </Checkbox>
            <Checkbox
              isChecked={filters.Funded}
              onChange={(e) => setFilters({ ...filters, Funded: e.target.checked })}
              colorScheme="purple"
              size="lg"
            >
              Funded
            </Checkbox>
            <Checkbox
              isChecked={filters.Incomplete}
              onChange={(e) => setFilters({ ...filters, Incomplete: e.target.checked })}
              colorScheme="purple"
              size="lg"
            >
              Incomplete
            </Checkbox>
            <Checkbox
              isChecked={filters.Closed}
              onChange={(e) => setFilters({ ...filters, Closed: e.target.checked })}
              colorScheme="purple"
              size="lg"
            >
              Closed
            </Checkbox>
            <Checkbox
              isChecked={filters.Deleted}
              onChange={(e) => setFilters({ ...filters, Deleted: e.target.checked })}
              colorScheme="purple"
              size="lg"
            >
              Deleted
            </Checkbox>
          </VStack>
        </DrawerBody>
        <Flex
          px={6}
          py={4}
          borderTop="1px solid"
          borderColor="gray.100"
          gap={3}
          bg="white"
        >
          <Button
            colorScheme="blue"
            size="lg"
            flex={1}
            onClick={handleApply}
            borderRadius="8px"
          >
            Apply
          </Button>
          <Button
            variant="outline"
            size="lg"
            flex={1}
            onClick={onCancel}
            borderRadius="8px"
            borderColor="gray.200"
          >
            Cancel
          </Button>
        </Flex>
      </DrawerContent>
    </Drawer>
  );
};

export default FilterDrawer;
